export default __webpack_public_path__ + "static/media/003-eggs.08205e30.svg";